<div
  class="mobile-menu container-xl d-flex flex-column pb-5 mih-100"
  [appStoryblok]="_editable"
>
  <app-mobile-menu-commands></app-mobile-menu-commands>
  <div class="row menu" *ngIf="!_menu">
    <div class="col-12" *ngFor="let blok of menus">
      <div class="menu-label action" (click)="_menu = blok; clickout($event)">
        {{ blok.title }}

        <svg
          class="ms-3"
          *ngIf="blok?.menus"
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            opacity="0.9"
            d="M4.62323 2.3856L8.98024 6.78685C9.03367 6.83282 9.03367 6.87873 8.98024 6.96144L4.61432 11.3535"
            stroke="black"
            stroke-width="2"
            stroke-linecap="square"
          />
        </svg>
      </div>
      <div class="menu-label">
        <ndc-dynamic
          *ngIf="components"
          [ndcDynamicComponent]="components[blok.component]"
          [ndcDynamicInputs]="blok"
        >
        </ndc-dynamic>
      </div>
    </div>
  </div>

  <div class="menu submenu" *ngIf="_menu?.menus">
    <svg
      (click)="_menu = null; clickout($event)"
      class="back action"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        opacity="0.9"
        d="M9.01142 2.38572L4.6544 6.78697C4.60097 6.83294 4.60097 6.87885 4.6544 6.96156L9.02032 11.3536"
        stroke="black"
        stroke-width="2"
        stroke-linecap="square"
      />
    </svg>
    <ng-container *ngFor="let subblok of _menu?.menus">
      <ndc-dynamic
        *ngIf="components"
        [ndcDynamicComponent]="components[subblok.component]"
        [ndcDynamicInputs]="subblok"
      >
      </ndc-dynamic>
    </ng-container>
  </div>
  <div class="row mt-auto" *ngIf="!_menu">
    <div class="col-12 mb-3">
      <a
        class="aux"
        (click)="navigate()"
        href="https://shopify.com/9607794/account"
      >
        <svg
          class="me-2 action account"
          width="20"
          height="22"
          viewBox="0 0 20 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 9.36914C12.2091 9.36914 14 7.57829 14 5.36915C14 3.16001 12.2091 1.36914 10 1.36914C7.79087 1.36914 6 3.16001 6 5.36915C6 7.57829 7.79087 9.36914 10 9.36914Z"
            stroke="black"
            stroke-width="2"
          />
          <path
            d="M19 21.3691C19 16.3986 14.9706 12.3691 10 12.3691C5.02945 12.3691 1 16.3986 1 21.3691"
            stroke="black"
            stroke-width="2"
          />
        </svg>
        Account
      </a>
    </div>
    <div class="col-12">
      <a class="aux" [routerLink]="['/wishlist']">
        <svg
          class="action wishlist me-2"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18 4.36914H6V19.3691L12 15.4079L18 19.3691V4.36914Z"
            [attr.stroke]="wishlist?.length > 0 ? '#DE178F' : 'black'"
            stroke-width="2"
            [attr.fill]="wishlist?.length > 0 ? '#DE178F' : 'transparent'"
            stroke-linecap="square"
          />
        </svg>
        Wishlist</a
      >
    </div>
  </div>
</div>
